/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from 'react';
import { Form, Table, ConfigProvider} from 'antd';
import { request } from '@/utils'
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const M3c1 = () => {
  
  
   const [bangm, setbangm] = useState([]);
  useEffect(() => {
    async function getau() {
      const res = await request.post('/p_paylist',{dow:"CZ"})
       setbangm(res.rescode)
    }
  
    getau()
  
  }, [])
  

 



 
 const columns = [
  
  {
    title: '订单编号',
    dataIndex: 'ddno',
    key: 'ddno',
  },
  {
    title: '金额',
    dataIndex: 'samount',
    key: 'samount',
  },
  {
    title: '支付方式',
    dataIndex: 'p_w',
    key: 'p_w',
  },
  {
    title: '支付时间',
    dataIndex: 'pay_time',
    key: 'pay_time',
  }
];
  

  

 









  const [form] = Form.useForm();
  return (<ConfigProvider locale={zhCN} >

    <div 
    // style={containerStyle} 
    >

      <Form form={form} component={false}>

      <Table  columns={columns} dataSource={bangm} rowKey="ddno"/>

      </Form>


      
    </div>

    
  </ConfigProvider>

  );
};
export default M3c1;